import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevrons-down",
  "use": "chevrons-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevrons-down\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m0 0 5 5 5-5\" transform=\"translate(7 13)\" /><path d=\"m0 0 5 5 5-5\" transform=\"translate(7 6)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol